import * as types from "../actions/actionTypes";

import initialState from "./initialState";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import { AccessInfo } from "../../../Shared/GeneratedTypes";

export default function accessInfoReducer(state = initialState.accessInfo, action: CurrentMentorsActions): AccessInfo {
    switch (action.type) {
        case types.LOAD_ACCESS_INFO_SUCCESS:
            return action.accessInfo;
        default:
            return state;
    }
}
